export interface Documentation {
    id: string;
    documentTitle: string;
    documentCategory: string;
    documentDescription: string;
    isExternalLink: boolean;
    publicLink: string;
    isDraft: boolean;
}

export interface DocumentationFormData {
    documentTitle: string;
    documentDescription?: string;
    documentCategory: string;
    publicLink?: string;
    isExternalLink: boolean;
    isDraft: boolean;
}